import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Blog() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get("/blog")
            .then(({ data }) => setArticles(data))
            .catch((e) => setError(formatApiError(e)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20" data-testid="blog-page">
            <Reveal>
                <span className="overline">Blog</span>
                <h1 className="mt-6 font-serif text-6xl md:text-7xl lg:text-8xl font-light text-brand-ink leading-[1.02] max-w-4xl">
                    Carnet
                    <span className="italic"> d'inspirations</span>.
                </h1>
                <p className="mt-8 text-xl text-brand-sageDark font-light max-w-2xl">
                    Conseils, tendances et réflexions sur la rénovation haut de gamme. Un journal pour celles et ceux
                    qui aiment penser leurs intérieurs avec exigence.
                </p>
            </Reveal>

            <div className="mt-20">
                {loading ? (
                    <p className="text-brand-sageDark font-light" data-testid="blog-loading">Chargement des articles…</p>
                ) : error ? (
                    <p className="text-red-700" data-testid="blog-error">{error}</p>
                ) : articles.length === 0 ? (
                    <div className="py-16 border-t border-brand-border" data-testid="blog-empty">
                        <p className="font-serif text-3xl text-brand-ink italic">Le blog s'écrit en ce moment.</p>
                        <p className="mt-3 text-lg text-brand-sageDark font-light">Les premiers articles seront publiés très prochainement.</p>
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
                        {articles.map((a, i) => (
                            <Reveal key={a.id} delay={i * 60}>
                                <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group block">
                                    <div className="hover-zoom aspect-[4/3] bg-brand-bgalt">
                                        {a.cover_image && (
                                            <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" />
                                        )}
                                    </div>
                                    <div className="mt-5">
                                        {a.tags?.length > 0 && (
                                            <span className="overline">{a.tags[0]}</span>
                                        )}
                                        <h2 className="mt-2 font-serif text-2xl text-brand-ink group-hover:text-brand-sage transition-colors">
                                            {a.title}
                                        </h2>
                                        <p className="mt-3 text-sm text-brand-sageDark font-light line-clamp-3">{a.excerpt}</p>
                                        <span className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-brand-sage">
                                            Lire l'article <ArrowUpRight size={14} />
                                        </span>
                                    </div>
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
